import { useIsMobile } from '../hooks/useIsMobile'
import styles from './RoutingFactorsTable.module.css'

// Result → pill color class. Neutral (grey), Positive (muted green), Negative (muted
// red), per the design doc.
const RESULT_CLASS = {
  Positive: styles.positive,
  Negative: styles.negative,
  Neutral: styles.neutral,
}

/**
 * RoutingFactorsTable — the "Routing Factors" tab on the case detail page. Shows why
 * the case routed as it did: Factor / Type / Evidence / Result, with a colored result
 * pill. (Data is stubbed by the backend this pass — no source on the node yet.)
 *
 * Props:
 *   factors {Array<{factor, type, evidence, result}>}
 */
export default function RoutingFactorsTable({ factors = [] }) {
  const isMobile = useIsMobile()

  if (!factors.length) {
    return <p className={styles.empty}>No routing factors available.</p>
  }

  if (isMobile) {
    return (
      <div className={styles.cardList}>
        {factors.map((f, i) => (
          <div className={styles.factorCard} key={i}>
            <div className={styles.factorCardHeader}>
              <span className={styles.factor}>{f.factor}</span>
              <span className={`${styles.resultPill} ${RESULT_CLASS[f.result] || styles.neutral}`}>
                {f.result}
              </span>
            </div>
            <div className={styles.field}>
              <span className={styles.fieldLabel}>Type</span>
              <span className={styles.typePill}>{f.type}</span>
            </div>
            <div className={styles.field}>
              <span className={styles.fieldLabel}>Evidence</span>
              <span className={styles.fieldValue}>{f.evidence}</span>
            </div>
          </div>
        ))}
      </div>
    )
  }

  return (
    <div className={styles.wrap}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Factor</th>
            <th>Type</th>
            <th>Evidence</th>
            <th className={styles.resultCol}>Result</th>
          </tr>
        </thead>
        <tbody>
          {factors.map((f, i) => (
            <tr key={i}>
              <td className={styles.factor}>{f.factor}</td>
              <td><span className={styles.typePill}>{f.type}</span></td>
              <td className={styles.evidence}>{f.evidence}</td>
              <td className={styles.resultCol}>
                <span className={`${styles.resultPill} ${RESULT_CLASS[f.result] || styles.neutral}`}>
                  {f.result}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
